var giphy_viewer_default = {
  "giphyWrapper": "C1wlU",
  "giphy_player": "dyp9p",
  "playIcon": "nE2hl",
  "gifRatio": "zOf-w"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
